import { Clipboard, Home } from 'react-feather';
export const MENUITEMS = [
    {
        path: '/dashboard', title: 'Dashboard', icon: Home, type: 'link', badgeType: 'primary', active: false
    }, 
    {
        title: 'Orders',
        icon: Clipboard,
        type: 'sub',
        active: false,
        children: [
            { path: '/orders/admin', title: 'Show Orders', type: 'link' },
            { path: '/orders/admin/shipping', title: 'Shipping', type: 'link' },
            { path: '/orders/admin/returns', title: 'Returns', type: 'link' },
        ]
    },

]
